import { useEffect, useState } from "react";

export const CountdownTimer = ({ endsAt, label = "Closes In" }) => {
  const [t, setT] = useState({ d: 0, h: 0, m: 0, s: 0, done: false });

  useEffect(() => {
    const tick = () => {
      const diff = new Date(endsAt).getTime() - Date.now();
      if (diff <= 0) return setT({ d: 0, h: 0, m: 0, s: 0, done: true });
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setT({ d, h, m, s, done: false });
    };
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, [endsAt]);

  if (t.done) return <div className="font-accent text-[11px] tracking-[0.28em] uppercase text-white/40">Auction Ended</div>;

  const Cell = ({ v, l }) => (
    <div className="flex flex-col items-center min-w-[64px] border border-white/10 px-3 py-3 bg-black/40">
      <span className="font-heading text-3xl text-ivory leading-none">{String(v).padStart(2, "0")}</span>
      <span className="font-accent text-[9px] tracking-[0.28em] uppercase text-white/40 mt-2">{l}</span>
    </div>
  );

  return (
    <div data-testid="countdown-timer">
      <div className="font-accent text-[10px] tracking-[0.28em] uppercase text-gold mb-3">{label}</div>
      <div className="flex gap-2">
        <Cell v={t.d} l="Days" />
        <Cell v={t.h} l="Hrs" />
        <Cell v={t.m} l="Min" />
        <Cell v={t.s} l="Sec" />
      </div>
    </div>
  );
};

export default CountdownTimer;
